import SingleSelector from "../SingleSelector";
import { useTranslation } from "@/langs/useTranslation";

const DeviceStatus = ({ name, value, onChange }) => {
  const { t } = useTranslation();

  return (
    <SingleSelector
      placeholder={t({ defaultMessage: "选择状态" })}
      clearable
      options={[
        { id: 0, name: t({ defaultMessage: "在线" }) },
        { id: 1, name: t({ defaultMessage: "离线" }) }
      ]}
      name={name}
      value={value}
      onChange={onChange}
    />
  );
};

export default DeviceStatus;
